import defaultState from "@/vue/utils/defaultState";
import { apiErrorHandler, oktaAxios as axios } from "@/vue/api/config";
import {
  PACKAGE_TYPES,
  PACKAGES,
} from "@/react/features/smp/licenses/constants";

const defState = defaultState("licenses", {
  [PACKAGE_TYPES.DID_REGULAR]: {
    licenses: [],
    available: false,
  },
  [PACKAGE_TYPES.DID_TOLLFREE]: {
    licenses: [],
    available: false,
  },
  [PACKAGE_TYPES.TRUNKS]: {
    licenses: [],
    available: false,
  },
});

export const licenses = {
  state: defState.state,
  getters: {
    licenses: (state) => (packageType) =>
      state[packageType] && state[packageType].licenses,
    licenseAvailability: (state) => (packageType) =>
      state[packageType] && state[packageType].available,
  },
  mutations: {
    ...defState.mutations,
    SET_AVAILABILITY(state, { packageType, availability }) {
      state[packageType].available = availability;
    },
  },
  actions: {
    async getLicenseAvailability({ commit }, { customerId, packageType }) {
      const data = {
        opts: {
          packageId: [PACKAGES[packageType]],
        },
      };
      const response = await axios
        .post(`/v1/customers/${customerId}/licenses/available`, data)
        .catch(apiErrorHandler);
      const availability = !!response.data;
      commit("SET_AVAILABILITY", { packageType, availability });
      return availability;
    },
  },
};
